export default __webpack_public_path__ + "static/media/190629_192557_DSCN2984.81ea5bc0.JPG";